import BasicModel from "./basic_model";
import Player from "./player";
import Ball from "./ball";

export default class PlayerWithBall extends BasicModel {
  render = () => {
    this.setupContext();

    const player = new Player();
    const ball = new Ball();

    player.origin = this.origin.slice();
    player.active = this.active;
    player.variation = this.variation;
    player.context = this.context;
    player.render();

    ball.origin = this.origin.slice();
    ball.origin[1] = ball.origin[1] + 18 * this.context.scale;
    ball.active = this.active;
    ball.context = this.context;
    ball.render();

    this.resetContext();
  }

  boundingBox = () => {
    const x = this.x();
    const y = this.y();
    const w = 15;
    const h = 20;
    const s = this.context.scale;

    return {
      x: x - w * s,
      y: y - 0.6 * h * s,
      w: 2 * w * s,
      h: 2 * h * s
    }
  }

}


